export default "__VITE_ASSET__CQSZ8Ijs__"